import React, { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { Button } from "../components/ui/button";
import { Download } from "lucide-react";

const AdminQuotes = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/quotes").then((r) => setItems(r.data.items)).catch(() => {}); }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/quotes/${id}/status?status=${status}`);
    setItems((arr) => arr.map((q) => (q.id === id ? { ...q, status } : q)));
  };

  return (
    <div>
      <h1 className="font-heading text-3xl font-bold text-[#2D3748]">Quotes</h1>
      <p className="text-[#718096] mt-1">AI-drafted quotes sent to customers.</p>
      <div className="mt-6 bg-white border border-[#E2E8F0] rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F7FAFC] text-[#718096] uppercase tracking-wider text-xs">
            <tr>
              <th className="text-left px-5 py-3">#</th>
              <th className="text-left px-5 py-3">Customer</th>
              <th className="text-left px-5 py-3">Business</th>
              <th className="text-right px-5 py-3">Total</th>
              <th className="text-left px-5 py-3">Status</th>
              <th className="text-right px-5 py-3">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#E2E8F0]">
            {items.map((q) => (
              <tr key={q.id} className="hover:bg-[#F7FAFC]" data-testid={`quote-row-${q.quote_number}`}>
                <td className="px-5 py-4 font-mono text-xs text-[#718096]">{q.quote_number}</td>
                <td className="px-5 py-4 text-[#2D3748] font-medium">{q.customer_name}</td>
                <td className="px-5 py-4 text-[#2D3748]">{q.business_name}</td>
                <td className="px-5 py-4 text-right font-heading font-semibold text-[#2D3748]">R {q.total.toFixed(2)}</td>
                <td className="px-5 py-4">
                  <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                    q.status === "approved" ? "bg-[#16A34A]/10 text-[#16A34A]"
                    : q.status === "sent" ? "bg-[#1E88E5]/10 text-[#1E88E5]"
                    : q.status === "rejected" ? "bg-[#DC2626]/10 text-[#DC2626]"
                    : "bg-[#F7FAFC] text-[#718096]"
                  }`}>{q.status}</span>
                </td>
                <td className="px-5 py-4 text-right space-x-2">
                  <a href={`${API}/public/quotes/${q.id}/pdf`} target="_blank" rel="noopener noreferrer" data-testid={`download-pdf-${q.id}`} className="inline-flex">
                    <Button size="sm" variant="outline" className="rounded-full text-xs"><Download className="w-3 h-3 mr-1" />PDF</Button>
                  </a>
                  {q.status === "draft" && (
                    <Button size="sm" data-testid={`send-quote-${q.id}`} onClick={() => updateStatus(q.id, "sent")} className="rounded-full text-xs bg-[#1E88E5] hover:bg-[#1565C0] text-white">Send</Button>
                  )}
                  {q.status === "sent" && (
                    <>
                      <Button size="sm" data-testid={`approve-quote-${q.id}`} onClick={() => updateStatus(q.id, "approved")} className="rounded-full text-xs bg-[#25D366] hover:bg-[#16A34A] text-white">Approve</Button>
                      <Button size="sm" data-testid={`reject-quote-${q.id}`} onClick={() => updateStatus(q.id, "rejected")} variant="outline" className="rounded-full text-xs">Reject</Button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-10 text-center text-[#718096]">No quotes yet. Generate one from the Leads tab.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminQuotes;
